import React from 'react';
import { Helmet } from 'react-helmet';
import background from '../assets/images/under_construction.png';

export default function UnderConstructionPage({ onBack }) {
  return (
    <>
      <Helmet>
        <title>Under Construction | Insight Data LLC</title>
      </Helmet>
      <button onClick={onBack} className="back-link" style={{ margin: '2rem 0 1rem 0' }}>
         Back
      </button>

      <div
        style={{
          height: '75vh',
          backgroundImage: `url(${background})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          
          display: 'flex',
          justifyContent: 'flex-start',
          paddingTop: '10rem',
          alignItems: 'center',
          flexDirection: 'column',
          padding: '1rem',
        }}
      >
        <h1 style={{ fontSize: '2.5rem', color: '#222', margin: 0 }}>
          Under Construction
        </h1>
        <p style={{ color: '#444', marginTop: '0.5rem' }}>
          Please check back soon!
        </p>
      </div>
    </>
  );
}
